module.exports = __webpack_public_path__ + "img/logokont.09f13a0d.jpg";